import React from "react";
import { Play, Pause, SkipForward, X, Scissors } from "lucide-react";

export default function ReplayToolbar({
  isReplayMode,
  isSelectingBar,
  onToggleSelectBar,
  onExitReplay,
  isPlaying,
  onTogglePlay,
  onStepForward,
  onResetReplay,
  currentIndex,
  totalBars,
  onSeek,
  replaySpeed,
  onChangeSpeed,
}) {
  if (!isReplayMode) return null;

  return (
    <div className="absolute bottom-3 sm:bottom-4 left-1/2 -translate-x-1/2 z-30 bg-slate-900/90 sm:bg-slate-900/95 border border-slate-700/80 hover:border-cyan-500/40 shadow-2xl shadow-black/80 rounded-full px-2 py-1 sm:px-2.5 sm:py-1.5 flex items-center gap-1 sm:gap-1.5 backdrop-blur-md text-xs font-sans animate-fadeIn select-none pointer-events-auto max-w-[95vw] overflow-x-auto scrollbar-none">
      {/* 1. Nút Cắt nến (TradingView scissors) */}
      <button
        onClick={onToggleSelectBar}
        className={`px-2.5 py-1 rounded-full flex items-center gap-1.5 font-medium transition cursor-pointer text-xs shrink-0 ${
          isSelectingBar
            ? "bg-amber-400 text-slate-950 font-bold shadow-md shadow-amber-400/30 animate-pulse"
            : "bg-slate-800/80 hover:bg-slate-700 text-cyan-300 hover:text-cyan-200 border border-cyan-500/30"
        }`}
        title={isSelectingBar ? "Nhấp vào bất kỳ cây nến nào trên biểu đồ để cắt..." : "Bấm để chọn điểm cắt nến"}
      >
        <Scissors className="w-3.5 h-3.5 shrink-0" />
        <span className="hidden sm:inline font-semibold">{isSelectingBar ? "Chọn nến..." : "Cắt nến"}</span>
        <span className="sm:hidden font-semibold">{isSelectingBar ? "Chọn..." : "Cắt"}</span>
      </button>

      <div className="h-4 w-px bg-slate-700/70 shrink-0" />

      {/* 2. Play / Pause Button */}
      <button
        onClick={onTogglePlay}
        className={`w-7 h-7 rounded-full flex items-center justify-center transition cursor-pointer shrink-0 ${
          isPlaying
            ? "bg-amber-400 text-slate-950 hover:bg-amber-300 shadow-sm shadow-amber-400/20"
            : "bg-cyan-500 text-slate-950 hover:bg-cyan-400 shadow-sm shadow-cyan-500/20"
        }`}
        title={isPlaying ? "Tạm dừng (Pause)" : "Phát tự động (Play)"}
      >
        {isPlaying ? (
          <Pause className="w-3.5 h-3.5 fill-current" />
        ) : (
          <Play className="w-3.5 h-3.5 fill-current ml-0.5" />
        )}
      </button>

      {/* 3. Step Forward 1 Bar */}
      <button
        onClick={onStepForward}
        disabled={currentIndex >= totalBars - 1}
        className="w-7 h-7 rounded-full flex items-center justify-center bg-slate-800/80 hover:bg-slate-700 text-slate-200 transition cursor-pointer shrink-0 disabled:opacity-30 disabled:cursor-not-allowed"
        title="Tiến 1 cây nến"
      >
        <SkipForward className="w-3.5 h-3.5" />
      </button>

      <div className="h-4 w-px bg-slate-700/70 shrink-0" />

      {/* 4. Speed Selector */}
      <div className="flex items-center gap-0.5 bg-slate-950/80 p-0.5 rounded-full border border-slate-800/80 shrink-0 text-[10px] font-semibold">
        {[
          { label: "0.5x", val: 1200 },
          { label: "1x", val: 600 },
          { label: "2x", val: 250 },
          { label: "5x", val: 80 },
          { label: "10x", val: 30 },
        ].map((spd) => (
          <button
            key={spd.label}
            onClick={() => onChangeSpeed(spd.val)}
            className={`px-1.5 py-0.5 rounded-full transition cursor-pointer ${
              replaySpeed === spd.val
                ? "bg-cyan-500 text-slate-950 font-bold shadow-xs"
                : "text-slate-400 hover:text-slate-200"
            }`}
          >
            {spd.label}
          </button>
        ))}
      </div>

      <div className="h-4 w-px bg-slate-700/70 shrink-0" />

      {/* 5. Close / Exit Button */}
      <button
        onClick={onExitReplay}
        className="w-7 h-7 rounded-full flex items-center justify-center bg-slate-800/80 hover:bg-rose-500/20 text-slate-400 hover:text-rose-400 transition cursor-pointer shrink-0"
        title="Thoát Bar Replay"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
